import React, { useState } from "react";
import { SlOption, SlSelect } from '@shoelace-style/shoelace/dist/react';

import CompetitorData from "./CompetitorData.js";
import Birdview from "./birdview.js";



function DefaultTab() {
    const [currentTab, setCurrentTab] = useState("newspaper")

    return (<>
        <div className="flex items-center gap-3 mb-3">

            <aside className="flex items-center gap-3 justify-center">
                <div className="flex">
                    <div>
                        <SlSelect
                            className='w-full'
                            placeholder="Select Type"
                            name="source"
                            size="small"
                            value={currentTab}
                            onSlChange={(e) => (setCurrentTab(e.target.value))}

                        >
                            <SlOption key={0} value={"newspaper"}>Print</SlOption>
                            <SlOption key={1} value={'competitor'}>Digital</SlOption>

                        </SlSelect>
                    </div>

                </div>

            </aside>
        </div>
        {(currentTab === "competitor") ? (<CompetitorData />) : <Birdview />}
    </>
    )

}

export default DefaultTab